import { $UserAgent } from '@lemon8/web-app-shared/atom';
import { useAtomValue } from 'jotai';

export const SEOKeywordsItem = (props: { keyword: string }) => {
  const { isBot } = useAtomValue($UserAgent);
  const { keyword } = props;

  return <>{isBot ? <strong>{keyword}</strong> : <>{keyword}</>}</>;
};
